import api from "./api";

export const getBalanceFromFitBank = async (balanceId) =>{
    let taxNumber = localStorage.getItem('taxNumber')
    let response = await api.patch(`/balance/update/${taxNumber}/${balanceId}`)
    return response.data.data.Balance
}